export const PDULI_RECORDING_REQUEST = "PDULI_RECORDING_REQUEST";
export const PDULI_RECORDING_SUCCESS = "PDULI_RECORDING_SUCCESS";
export const PDULI_RECORDING_FAIL = "PDULI_RECORDING_FAIL";
export const PDULI_RECORDING_RESET = "PDULI_RECORDING_RESET";
